import { SINGLE_NUMERIC } from './_argShapes';
import { STUB_NOT_IMPLEMENTED } from './_stubs';
import type { EffectEntry } from './types';

export const phaser: EffectEntry = {
  kind: 'phaser',
  category: 'effect',
  family: 'modulation',
  doc: 'phaser mix (0 off, 0.5 classic, 1 full wet)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('phaser', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('phaser', 'fromAst'),
};

export const phaserdepth: EffectEntry = {
  kind: 'phaserdepth',
  category: 'effect',
  family: 'modulation',
  doc: 'phaser sweep depth (0–1)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('phaserdepth', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('phaserdepth', 'fromAst'),
};

export const phaserfreq: EffectEntry = {
  kind: 'phaserfreq',
  category: 'effect',
  family: 'modulation',
  doc: 'phaser rate in Hz (0.1 slow, 2 fast)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('phaserfreq', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('phaserfreq', 'fromAst'),
};

export const phaserrate: EffectEntry = {
  kind: 'phaserrate',
  category: 'effect',
  family: 'modulation',
  doc: 'alias of phaserfreq on some builds',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('phaserrate', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('phaserrate', 'fromAst'),
};

export const chorus: EffectEntry = {
  kind: 'chorus',
  category: 'effect',
  family: 'modulation',
  doc: 'stereo chorus depth (0 dry, 1 wet)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('chorus', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('chorus', 'fromAst'),
};

export const noise: EffectEntry = {
  kind: 'noise',
  category: 'effect',
  family: 'modulation',
  doc: 'blends white noise in (0–0.3 air, 1 harsh)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('noise', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('noise', 'fromAst'),
};

export const unison: EffectEntry = {
  kind: 'unison',
  category: 'effect',
  family: 'modulation',
  doc: 'detune N voices per note (2–8 thicker)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('unison', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('unison', 'fromAst'),
};

export const detune: EffectEntry = {
  kind: 'detune',
  category: 'effect',
  family: 'modulation',
  doc: 'cents of unison spread (0 none, 25 shimmer, 100+ wild)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('detune', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('detune', 'fromAst'),
};
